import { createFileRoute } from '@tanstack/react-router'
import { AdminPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/admin/')({
  head: () => noIndexRouteHead('admin', 'it'),
  component: AdminPage,
})
